module.exports = __webpack_public_path__ + "img/01-wide.d3d2988d.svg";